export interface Distributor {
  id: number;
  uuid: string;
  name: string;
  emailAddress: string | null;
  phoneNumber: string | null;
  logoUrl: string | null;
}

export interface DistributorQueryData {
  distributorByUuid: Distributor | null;
}

export interface RecentQuote {
  id: number;
  uuid: string;
  description: string | null;
  type: string | null;
  createdAt: string | null;
  revisions: { options: { updatedAt: string | null }[] }[];
}

export interface RecentQuotesQueryData {
  quotes: RecentQuote[];
  quoteSummary: { count: number };
}

export interface PortalNotification {
  subject: string;
  description: string | null;
  updatedAt: string | null;
}

export interface NotificationsQueryData {
  notifications: PortalNotification[];
}

/**
 * When a quotation last changed, taken from its options rather than the quote
 * row — see the comment on RECENT_QUOTES_QUERY. Null when it has no options
 * yet, which is a quotation that was started and never priced.
 */
export function lastTouched(quote: RecentQuote): string | null {
  const dates = quote.revisions
    .flatMap((revision) => revision.options)
    .map((option) => option.updatedAt)
    .filter((value): value is string => !!value);
  if (dates.length === 0) return null;
  return dates.reduce((latest, date) => (date > latest ? date : latest));
}
